import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=0ba3c6db&scoped=true"
import script from "./ModalCadastro.vue?vue&type=script&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastro.vue?vue&type=style&index=0&id=0ba3c6db&prod&lang=scss&scoped=true"
import style1 from "./ModalCadastro.vue?vue&type=style&index=1&id=0ba3c6db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3c6db",
  null
  
)

export default component.exports